import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaFacebook } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="line-footer"></div>
            <div className="footer-container">
                {/* About Section */}
                <div className="footer-section about">
                    <h3 className="footer-logo">Sumber Lancar</h3>
                    <p className='footer-description'>
                        Sejak berdiri pada tahun 2018, Toko Besi & Bahan Bangunan Sumber Lancar hadir sebagai mitra setia dalam setiap pembangunan. Kami percaya, setiap proyek besar berawal dari material yang berkualitas. Karena itu, kami berkomitmen untuk menyediakan produk terbaik, layanan terpercaya, dan solusi yang memudahkan pelanggan dalam mewujudkan setiap rencana menjadi kenyataan.                    </p>
                </div>

                {/* Links */}
                <div className="footer-section links">
                    <h4>Navigasi</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/cart">Keranjang</Link></li>
                        <li><Link to="/profile">Profil Saya</Link></li>
			<li><Link to="/about">Tentang Kami</Link></li>
			<li><Link to="/how-to-use">Cara Pakai Website</Link></li>

                    </ul>
                </div>

                {/* Contact */}
                <div className="footer-section contact">
                    <h4>Hubungi Kami</h4>
                    <p>Jl. Patimura Pasar Anyar No. 14 Salatiga</p>
                    <p>sumberlancarsalatiga@gmail.com</p>
                    <p>Telp / Whatsapp: 0851-3336-7953</p>
                </div>

                {/* Social */}
                <div className="footer-section social">
                    <h4>Ikuti Kami</h4>
                    <div className="social-icons">
                        <a href="https://wa.me/6285133367953" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
                        <a href="https://instagram.com/tb.sumber_lancar" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Sumber Lancar. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
